module.exports = __webpack_public_path__ + "static/media/ico_plans.98131675.svg";